<script>
/* eslint-disable @typescript-eslint/ban-ts-comment */
import Input from '@ilteducation/vuetify-admin/src/mixins/input';
import Editable from '@ilteducation/vuetify-admin/src/mixins/editable';
import { nanoid } from 'nanoid';
import SectionConfigurator from '@/components/view/SectionConfigurator.vue';
import MovableItem from '@/components/base/MovableItem.vue';

export default {
  name: 'ViewsDragInput',
  components: {
    MovableItem,
    SectionConfigurator,
  },
  mixins: [Input, Editable],
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    realm: {
      type: String,
    },
    subscription: {
      type: String,
    },
  },
  data() {
    return {
      sections: [],
      dragging: false,
      dialog: false,
      componentData: {
        props: {
          type: 'transition',
          name: 'flip-list',
        },
      },
    };
  },
  async created() {
    this.sections = this.value;
    console.log(this.sections);
  },
  methods: {
    pushUpdate() {
      this.update(this.sections);
    },
    addSection() {
      this.sections.unshift({ id: nanoid(5), selectors: [] });
      this.pushUpdate();
    },
    change() {
      this.pushUpdate();
    },
    removeSection(sectId) {
      const remIndex = this.sections.findIndex((sect) => sect.id === sectId);
      if (remIndex >= 0) {
        this.sections.splice(remIndex, 1);
      } else {
        console.log('Failed to remove section');
      }
      this.pushUpdate();
    },
    getSectionIndexById(id) {
      return this.sections.findIndex((sect) => sect.id === id);
    },
    updateSection(section) {
      const repIndex = this.getSectionIndexById(section.id);
      if (repIndex >= 0) {
        this.sections[repIndex] = section;
      } else {
        console.log('Failed to replace section');
      }
      this.pushUpdate();
    },
    onUpdateItems(sections) {
      this.sections = sections;
      this.pushUpdate();
    },
    onAdd() {
      this.dialog = true;
    },
  },
};
</script>

<template>
  <div>
    <v-row>
      <va-action-button label="Add Section" class="add-section-button" @click="addSection" />
    </v-row>
    <v-row>
      <v-col cols="12">
        <draggable
          tag="transition-group"
          draggable=".item"
          :component-data="componentData"
          :list="sections"
          class="drag-area"
          :animation="100"
          @start="dragging = true"
          @end="dragging = false"
          @change="change"
        >
          <div v-for="section in sections" :key="section.id" class="list-group-item item drag-section">
            <MovableItem dark @update:items="onUpdateItems" :item="section" :items="sections" @add="onAdd(section.id)">
              <div class="pa-2">
                <SectionConfigurator
                  :section="section"
                  :subscription="subscription"
                  :realm="realm"
                  :selectors="section.selectors"
                  @update-section="updateSection"
                  @remove-section="removeSection"
                />
              </div>
            </MovableItem>
          </div>
        </draggable>
      </v-col>
    </v-row>
  </div>
</template>

<style scoped>
.drag-area {
  border: 1px;
  border-color: #ffffff;
  background-color: rgba(216, 134, 198, 0.2);
}

.drag-section {
  border: 1px;
  border-color: #ffffff;
  background-color: rgba(134, 170, 216, 0.2);
}

.add-section-button {
  padding-bottom: 20px;
}

.img-wrap .close {
  position: absolute;
  top: 2px;
  right: 2px;
  z-index: 1;
  background-color: #fff;
  padding: 0px 0px 0px;
  color: #000;
  font-weight: bold;
  cursor: pointer;
  opacity: 0.2;
  align: center;
  text-align: center;
  font-size: 22px;
  line-height: 10px;
  border-radius: 50%;
}
</style>
